<ccl-palette title="Page elements">
    <div
        class="layout-container L_filter P_session"
        [ngClass]="{
            C_vip: sharedService.catalogLayoutConfig.vipUnit == 'card',
            L_vip: sharedService.catalogLayoutConfig.vipUnit == 'list',
            N_vip: sharedService.catalogLayoutConfig.vipUnit == 'none',
            C_speakers: sharedService.catalogLayoutConfig.listType == 'card',
            L_speakers: sharedService.catalogLayoutConfig.listType == 'list'
        }"
    >
        <div
            src="img/spacer.gif"
            class="layout-navbox header"
            [ngClass]="sharedService.currentLayoutSection == 'header' ? 'active' : ''"
            (cclClick)="navigateTo('header')"
            cclTitle="Edit header"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox html"
            [ngClass]="sharedService.currentLayoutSection == 'html-top' ? 'active' : ''"
            (cclClick)="navigateTo('html-top')"
            cclTitle="Edit html"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox tabs"
            [ngClass]="sharedService.currentLayoutSection == 'tabs' ? 'active' : ''"
            (cclClick)="navigateTo('tabs')"
            cclTitle="Edit tabs"
        ></div>

        <div
            src="img/spacer.gif"
            class="layout-navbox speakers vip"
            [ngClass]="sharedService.currentLayoutSection == 'highlighted-speaker' ? 'active' : ''"
            (cclClick)="navigateTo('highlighted-speaker')"
            cclTitle="Edit Featured speaker layout"
        ></div>

        <div
            src="img/spacer.gif"
            class="layout-navbox speakers general"
            [ngClass]="sharedService.currentLayoutSection == 'general-speaker' ? 'active' : ''"
            (cclClick)="navigateTo('general-speaker')"
            cclTitle="Edit General speaker layout"
        ></div>

        <div
            src="img/spacer.gif"
            class="layout-navbox html"
            [ngClass]="sharedService.currentLayoutSection == 'html-bottom' ? 'active' : ''"
            (cclClick)="navigateTo('html-bottom')"
            cclTitle="Edit html"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox footer"
            [ngClass]="sharedService.currentLayoutSection == 'footer' ? 'active' : ''"
            (cclClick)="navigateTo('footer')"
            cclTitle="Edit footer"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox speaker"
            [ngClass]="sharedService.currentLayoutSection == 'speaker' ? 'active' : ''"
            (cclClick)="navigateTo('speaker')"
            cclTitle="Edit speaker layout"
        ></div>

        <div
            src="img/spacer.gif"
            class="layout-navbox speaker_sessions"
            [ngClass]="sharedService.currentLayoutSection == 'speaker-sessions' ? 'active' : ''"
            (cclClick)="navigateTo('speaker-sessions')"
            cclTitle="Edit Speaker Sessions Template"
        >
            <i class="fa fa-list-alt fa-lg" aria-hidden="true"></i>
            <h4>Speaker Sessions</h4>
        </div>
        <div class="clearfix"></div>
    </div>

    <div class="s-palette__detail">
        <ccl-section-wrapper>
            <router-outlet></router-outlet>
        </ccl-section-wrapper>
    </div>
</ccl-palette>
